import { createAsyncThunk } from "@reduxjs/toolkit";

import { type DiscountDTO } from "@fitness-app/data-models/entities/Discount";
import { getErrorMessage } from "@fitness-app/utils";

import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { DISCOUNT_REDUCER_NAME } from "../types";
import { CloudFunctions } from "@fitness-app/data-models/http/registry";
import { callFn } from "../../../../helpers/callFn";

export const updateDiscount = createAsyncThunk<void, ActionParams<DiscountDTO>, AsyncThunkCreator<string>>(
  `${DISCOUNT_REDUCER_NAME}/updateDiscount`,
  async ({ payload, onSuccess, onFailure }, { rejectWithValue, extra: { analytics, auth, productApi } }) => {
    try {
      await getLoggedUser(auth);

      await callFn(productApi, CloudFunctions.products.routes.updateDiscount, payload);
      analytics.track("update_discount", {
        discountId: payload.id,
        action: payload.action,
      });
      onSuccess?.();
    } catch (e) {
      const status = (e as { response?: { status?: number } })?.response?.status;
      onFailure?.(status);

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
